export class Directory {
  name: string;
  code: string;
  directories: any[];
  files: any[];
  expanded = false;
  checked = false;
  constructor(name, directories, code?, files?) {
    this.name = name;
    this.files = files || [];
    this.directories = directories;
    this.expanded = false;
    this.checked = false;
    this.code = code;
  }

  toggle() {
    this.expanded = !this.expanded;
  }

  check() {
    const newState = !this.checked;
    this.checked = newState;
    this.checkRecursive(newState);
  }

  checkRecursive(state) {
    this.directories.forEach((d) => {
      d.checked = state;
      d.checkRecursive(state);
    });
  }
}
